module.exports = __webpack_public_path__ + "img/voucher_expired.5323cfed.svg";